import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-0" }
const _hoisted_2 = { class: "text-muted lead" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_ContractDetailTable = _resolveComponent("ContractDetailTable")!
  const _component_ContractDetailChangeCard = _resolveComponent("ContractDetailChangeCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackButton, {
      label: _ctx.$t('myCadac.contractDetail.button.back')
    }, null, 8, ["label"]),
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.vm.editing ? _ctx.$t("myCadac.contractDetail.titleChange") : _ctx.$t("myCadac.contractDetail.titleView")), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("myCadac.contractDetail.contractNumber", {
				contractNumber: _ctx.vm.contract.contractId,
			})), 1),
    _hoisted_3,
    _createVNode(_component_ContractDetailTable, {
      contracts: [_ctx.vm.contract],
      vm: _ctx.vm
    }, null, 8, ["contracts", "vm"]),
    (_ctx.vm.contract.contractLines.length)
      ? (_openBlock(), _createBlock(_component_ContractDetailChangeCard, {
          key: 0,
          vm: _ctx.vm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}